import { Typography } from 'omakase';
import { capitalize } from 'es-toolkit/compat';
import { core } from '@tock/coretypes';

interface Props {
  parkingOptionsOffered: core.BusinessParkingOption.ParkingOption[];
}

const parkingOptionDisplayNameMap: {
  [K in core.BusinessParkingOption.ParkingOption]: string;
} = {
  ON_SITE: 'on-site',
  VALET: 'valet',
  STREET: 'street parking',
};

const ParkingInformation: React.FunctionComponent<Props> = ({ parkingOptionsOffered }) => {
  const parkingString = `Parking: ${capitalize(
    parkingOptionsOffered
      .map((option) => parkingOptionDisplayNameMap[option])
      .sort()
      .join(', ')
  )}`;

  return (
    <Typography component="span" data-testid="parking-information-primary" variant="body02">
      {parkingOptionsOffered.length > 0 && parkingString}
    </Typography>
  );
};

export default ParkingInformation;
